(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-bundle-product-bk"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const bundleBtn = document.getElementById('BundleAddToCart');

    if (!bundleBtn) return;

    bundleBtn.addEventListener('click', async () => {
      const items = [];

      document.querySelectorAll('.bundle-variant-id').forEach((input) => {
        if (input.value) {
          items.push({
            id: Number(input.value),
            quantity: 1,
          });
        }
      });

      try {
        bundleBtn.disabled = true;
        bundleBtn.classList.add('loading');
        bundleBtn.innerText = 'Adding...';

        /* 1. ADD TO CART */
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!addResponse.ok) {
          throw new Error('Failed to add bundle');
        }

        /* 2. UPDATE CART BUBBLE */
        const headerResponse = await fetch('/?section_id=header');
        const headerText = await headerResponse.text();

        const headerDoc = document.createElement('div');
        headerDoc.innerHTML = headerText;

        const newCartIcon = headerDoc.querySelector('#cart-icon-bubble');
        const currentCartIcon = document.querySelector('#cart-icon-bubble');

        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }

        /* 3. FIX CART DRAWER STATE (IMPORTANT) */
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
          const drawerResponse = await fetch('/?section_id=cart-drawer');
          const drawerHTML = await drawerResponse.text();

          const drawerDoc = document.createElement('div');
          drawerDoc.innerHTML = drawerHTML;

          const newDrawer = drawerDoc.querySelector('cart-drawer');

          if (newDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }

          /* ✅ IMPORTANT: FORCE STATE SYNC */

          fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              if (cart.item_count > 0) {
                cartDrawer.classList.remove('is-empty');
                cartDrawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              } else {
                cartDrawer.classList.add('is-empty');
              }
            });

          /* CLOSE DRAWER */
          document.addEventListener('click', (e) => {
            if (e.target.closest('.drawer__close')) {
              cartDrawer.classList.remove('active');
              document.body.classList.remove('overflow-hidden');
            }
          });

          /* notify Dawn cart system */
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
            })
          );
        }

        /* SUCCESS STATE */
        bundleBtn.innerText = 'Added Successfully';

        setTimeout(() => {
          bundleBtn.innerText = 'Add Set to Cart';
        }, 2000);
      } catch (error) {
        console.error(error);

        bundleBtn.innerText = 'Failed';

        setTimeout(() => {
          bundleBtn.innerText = 'Add Set to Cart';
        }, 2000);
      } finally {
        bundleBtn.disabled = false;
        bundleBtn.classList.remove('loading');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-bundle-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const bundleBtn = document.getElementById('BundleAddToCart');

    async function refreshCart(openDrawer = true) {
      try {
        /* Refresh Cart Drawer */
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
          const drawerResponse = await fetch('/?section_id=cart-drawer');
          const drawerHTML = await drawerResponse.text();

          const drawerDoc = document.createElement('div');
          drawerDoc.innerHTML = drawerHTML;

          const newDrawer = drawerDoc.querySelector('cart-drawer');

          if (newDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }

          cartDrawer.classList.remove('is-empty');

          if (openDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        /* Refresh Cart Bubble */
        const headerResponse = await fetch('/?section_id=header');
        const headerHTML = await headerResponse.text();

        const headerDoc = document.createElement('div');
        headerDoc.innerHTML = headerHTML;

        const newBubble = headerDoc.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error(error);
      }
    }

    /* Swatch color change */
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.swatch');

      if (!swatch) return;

      const item = swatch.closest('.bundle-product-item');

      /* Active state */
      item.querySelectorAll('.swatch').forEach((s) => {
        s.classList.remove('active');
      });

      swatch.classList.add('active');

      const variantId = swatch.dataset.variantId;
      const imageUrl = swatch.dataset.image;
      const price = swatch.dataset.price;

      /* Change image */
      const image = item.querySelector('.bundle-product-main-image');

      if (image && imageUrl) {
        image.src = imageUrl;
        image.setAttribute('src', imageUrl);

        /* Remove Shopify responsive image sources */
        image.removeAttribute('srcset');
        image.removeAttribute('data-srcset');
      }

      /* Update checkbox variant */
      const checkbox = item.querySelector('.bundle-product-checkbox');

      if (checkbox) {
        checkbox.dataset.variantId = variantId;
      }

      /* Update Add To Cart variant */
      const addButton = item.querySelector('.single-product-add');

      if (addButton) {
        addButton.dataset.variantId = variantId;
      }

      /* Update displayed price */
      const priceElement = item.querySelector('.new-price');

      if (priceElement) {
        priceElement.textContent = price;
      }
    });

    /* ---------------------------
     SINGLE PRODUCT ADD TO CART
  ---------------------------- */

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.single-product-add');

      if (!button) return;

      const variantId = button.dataset.variantId;

      try {
        button.disabled = true;
        button.textContent = 'Adding...';

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
         

          throw new Error(errorData.description || 'Add to cart failed');
        }

        await refreshCart(true);
        /* Uncheck current product */
        const checkbox = button.closest('.bundle-product-item')?.querySelector('.bundle-product-checkbox');

        if (checkbox) {
          checkbox.checked = false;
        }
        button.textContent = 'Added';

        setTimeout(() => {
          button.textContent = 'Add to Cart';
        }, 2000);
      } catch (error) {
        console.error(error);

        button.textContent = 'Failed';

        setTimeout(() => {
          button.textContent = 'Add to Cart';
        }, 2000);
      } finally {
        button.disabled = false;
      }
    });

    /* ---------------------------
     BUNDLE ADD TO CART
  ---------------------------- */

    if (bundleBtn) {
      const btnLabel = bundleBtn.querySelector('.btnlabel');
      const originalText = btnLabel.textContent;
      bundleBtn.addEventListener('click', async () => {
        const items = [];

        const checkedProducts = document.querySelectorAll('.bundle-product-checkbox:checked');

        /* Selected products only */
        if (checkedProducts.length > 0) {
          checkedProducts.forEach((checkbox) => {
            items.push({
              id: Number(checkbox.dataset.variantId),
              quantity: 1,
            });
          });
        } else {
          /* No selection = add all products */
          document.querySelectorAll('.bundle-product-checkbox').forEach((checkbox) => {
            items.push({
              id: Number(checkbox.dataset.variantId),
              quantity: 1,
            });
          });
        }

        try {
          bundleBtn.disabled = true;
          btnLabel.textContent = 'Adding...';

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            throw new Error('Bundle add failed');
          }

          await refreshCart(true);

          /* Reset bundle selections */
          document.querySelectorAll('.bundle-product-checkbox').forEach((checkbox) => {
            checkbox.checked = false;
          });

          btnLabel.textContent = 'Added Successfully';

          setTimeout(() => {
            btnLabel.textContent = originalText;
          }, 2000);
        } catch (error) {
          console.error(error);

          btnLabel.textContent = 'Failed';

          setTimeout(() => {
            btnLabel.textContent = originalText;
          }, 2000);
        } finally {
          bundleBtn.disabled = false;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
